import * as Animate from "react-reveal";
import IntroImg from "../../../assets/images/png/pay 3.png";

const markStyle = {
  background: "linear-gradient(transparent 66%, #fbaf1be6 0)",
  padding: "0 0.08em",
  color: "inherit",
};

const PayWhySection = () => {
  return (
    <section className="bg-white py-16 lg:py-[105px] px-6 lg:px-8" id="why">
      <div className="container mx-auto grid pay-grid-78-22 gap-10 lg:gap-[75px] items-center">
        <Animate.Fade bottom>
          <div>
            <p className="text-[#986500] tracking-[0.1em] uppercase text-[15px] font-black mb-4">
              Payroll Is A People Experience
            </p>
            <h2
              className="text-primary tracking-[-0.05em] leading-[1.06] font-black mb-6"
              style={{ fontSize: "clamp(38px, 4.4vw, 61px)" }}
            >
              One process for finance.{" "}
              <mark style={markStyle}>A better experience for everyone.</mark>
            </h2>
            <span className="text-[#5c6274] text-[18px] leading-[1.75] block">
              Global payroll can become a maze of spreadsheets, messages and
              country-by-country follow-ups. Utiva Pay brings the work into a
              coordinated rhythm without losing the human context behind every
              payment.
            </span>
            <a
              href="https://app.utiva.co/signup?goal=workforce"
              target="_blank"
              rel="noreferrer noopener"
              className="text-primary inline-flex items-center gap-[14px] text-[16px] font-black mt-[29px] hover:text-[#03046b] transition"
            >
              Discuss your team with Utiva <span aria-hidden="true">↗</span>
            </a>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div
            className="bg-primary rounded-[28px] relative overflow-hidden"
            style={{ height: "590px" }}
          >
            <img
              src={IntroImg}
              alt="A payroll specialist talking with a business leader."
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div
              className="absolute flex justify-between items-center gap-5 rounded-[14px] px-6 py-5"
              style={{
                bottom: "24px",
                left: "24px",
                right: "24px",
                background: "rgba(255,255,255,0.94)",
                border: "1px solid rgba(255,255,255,0.38)",
                backdropFilter: "blur(15px)",
                WebkitBackdropFilter: "blur(15px)",
              }}
            >
              <span className="text-[#956100] text-[15px] font-black">
                Payroll Complete
              </span>
              <strong className="text-primary text-[18px]">
                Every person accounted for.
              </strong>
            </div>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default PayWhySection;
